import { api } from '../../api.js';
import { config } from '../../config.js';

const actions = {
    BACK_SGA_EVENTS : function(_, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.sga.events'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SGA_EVENTS_PRODUCTS : function(_, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.sga.events.products'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}
export default {
    actions
};